/**
 * @return {string}
 */
function Serialize(obj, prefix) {
    const str = [];
    for (let p in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, p)) {
            const key = prefix ? `${prefix}[${p}]` : p;
            const value = obj[p];
            if (value !== null && typeof value === 'object') {
                str.push(this.Serialize(value, key));
            } else {
                str.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
        }
    }
    return str.join('&');
}

function Deserialize(str) {
    return str
        ? JSON.parse(
              '{"' + str.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
              function (key, value) {
                  return key === '' ? value : decodeURIComponent(value);
              }
          )
        : {};
}
export { Serialize, Deserialize };
